export default __webpack_public_path__ + "static/media/ivr_red.1f313f0a.svg";